import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { ShippingPage } from './pages/ShippingPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { SitemapPage } from './pages/SitemapPage';
import { ModelChartsPage } from './pages/ModelChartsPage';
import { ContactPage } from './pages/ContactPage';
import { CareersPage } from './pages/CareersPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<HomePage data-id="element-3" />} data-id="element-2" />
        <Route path="/about" element={<AboutPage data-id="element-5" />} data-id="element-4" />
        <Route path="/shipping" element={<ShippingPage data-id="element-7" />} data-id="element-6" />
        <Route path="/privacy" element={<PrivacyPage data-id="element-9" />} data-id="element-8" />
        <Route path="/ProductCatalogSitemap.html" element={<SitemapPage data-id="element-11" />} data-id="element-10" />
        <Route path="/model-charts" element={<ModelChartsPage data-id="element-13" />} data-id="element-12" />
        <Route path="/careers" element={<CareersPage data-id="element-15" />} data-id="element-14" />
        <Route path="/contact" element={<ContactPage data-id="element-17" />} data-id="element-16" />
      </Routes>
    </BrowserRouter>;
}